import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useClickOutside } from "hooks/useClickOutside";
import ChangeCompanyIMG from "img/icons/entities/company_suit.svg";
import "./index.scss";

const getUserInitials = (first_name, last_name) => {
  const first = (first_name ?? "").trim();
  const last = (last_name ?? "").trim();

  if (!first && !last) return "";

  const firstLetter = first?.at(0)?.toUpperCase() ?? "";
  const lastLetter = last?.at(0)?.toUpperCase() ?? "";

  if (firstLetter && lastLetter) return `${firstLetter}${lastLetter}`;
  if (firstLetter) return `${firstLetter}${firstLetter}`;
  if (lastLetter) return `${lastLetter}${lastLetter}`;
  return "";
};

const UserProfile = ({ onChangeCompanyClick, isVisible, handleClose }) => {
  const user = useSelector((state) => state.user?.user) || {};
  const { email, first_name, last_name } = user;

  const initials = useMemo(
    () => getUserInitials(first_name, last_name),
    [first_name, last_name]
  );
  const userName = useMemo(() => {
    const name = [first_name, last_name].filter(Boolean).join(" ").trim();
    return name || email || "User";
  }, [first_name, last_name, email]);
  const photoUrl = user?.photo || user?.picture || null;

  const userProfileRef = useClickOutside(handleClose);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="userProfile" ref={userProfileRef}>
      <div className="userProfile-Wrapper">
        <div className="userProfile-header">
          <div className="userProfile-avatarWrap" aria-hidden>
            <div
              className="userProfile-avatar"
              style={{
                backgroundColor: photoUrl ? "transparent" : "#E4F3FE",
              }}
              title={userName}
            >
              {photoUrl ? (
                <img src={photoUrl} alt={userName} />
              ) : (
                initials
              )}
            </div>
          </div>
          <div className="userProfile-who">
            <div className="userProfile-name" title={userName}>
              {userName}
            </div>
            {!!email && (
              <div className="userProfile-email" title={email}>
                {email}
              </div>
            )}
          </div>
        </div>
        <div className="userProfile-content">
          <button
            type="button"
            className="userProfile-content-option"
            onClick={onChangeCompanyClick}
          >
            <img src={ChangeCompanyIMG} alt="" />
            <span>Change company</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
